import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import {
  MdArrowForwardIos,
  MdOutlineFavorite,
  MdOutlineFavoriteBorder,
} from "react-icons/md";

import Slider from "../../UI/toast/Carousel/Slider";
import { AiOutlineArrowRight } from "react-icons/ai";
import { useRouter } from "next/router";
import { useAuthModal } from "../../auth/modalcontext";
import { useAuth } from "../../../auth/AuthProvider";
import { favoriteProperty } from "../../../utils/property/favoriteProperty";
import { capture } from "../../../utils/analytics/capture";
import moment from "moment";
// import { BiLogoWhatsapp } from "react-icons/bi";
// import { IoCallOutline } from "react-icons/io5";

function PropertyTownHit({
  hit,
  onClick,
  sendEvent,
  loadingProperty,
  setLoadingProperty,
  dataSource,
  selectedPropertyId,
  reff,
  index,
  count,
  town,
}) {
  const [propImages, setPropImages] = useState(null);

  const router = useRouter();

  const [favorite, setFavorite] = useState(false);

  // const [loadingProperty, setLoadingProperty] = useState(null)

  let propertyID = dataSource === "FIRESTORE" ? hit.propertyID : hit.objectID;

  const [isIntersecting, setIntersecting] = useState(false);

  // console.log(town.tag.contactCTA);

  const [color, setColor] = useState("blue");

  useEffect(() => {
    setColor("red");
  }, []);

  //console.log(hit)
  let featureImage = Object.entries(hit.images).find(
    (el) => el[1]?.isFeatureImage === true
  );
  // console.log(Object.entries(hit.images))
  const { ref } = useInView({
    triggerOnce: true,
    rootMargin: "10%",
    onChange: (inView) => {
      if (inView) {
        setIntersecting(true);
        capture({
          category: "browse",
          event: "impression",
          properties: {
            ...hit,
            type: "property",
          },
        });
      }
    },
  });

  // useEffect(() => {
  //   const dbRef = rtRef(getDatabase());
  //   get(child(dbRef, `PropertyImages/${propertyID}`))
  //     .then((snapshot) => {
  //       if (snapshot.exists()) {
  //         setPropImages(snapshot.val());
  //       } else {
  //         console.log("No data available");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, [hit, propertyID]);

  // console.log(propImages);

  const title = `${
    (hit.noOfBedrooms === 0
      ? hit.propertyType
      : hit.noOfBedrooms + " bedroom " + hit.propertyType) +
    " for " +
    hit.listingType.toLowerCase() +
    " in " +
    hit.propertyTown.townName +
    (hit.listingType === "RENT"
      ? ` - Kshs ${Intl.NumberFormat().format(hit.monthlyRent)}/mo -`
      : ` - Kshs ${Intl.NumberFormat().format(hit.price)} - `) +
    // " " +
    // (property.propertyArea.descriptor
    //   ? property.propertyArea.descriptor.toLowerCase()
    //   : " ") +
    // " " +
    hit.propertyArea.areaName +
    ", " +
    hit.propertyCounty.countyName +
    " county "
  }`;

  const authModal = useAuthModal();
  // user
  const contextAuth = useAuth();
  const user = contextAuth.user;
  const claims = contextAuth.claims;

  useEffect(() => {
    setFavorite(user ? hit?.savedBy?.includes(user.uid) : false);
  }, [user]);

  // console.log(hit["inputData.addedTime"]);

  const addedWeeks = moment().diff(
    moment(new Date(hit?.inputData?.addedTime)).format("YYYY-MM-DD"),
    "weeks"
  );

  return (
    <div
      ref={(el) => {
        reff(el);
        ref(el);
      }}
      className={
        "  flex h-[22rem] w-full cursor-pointer select-none flex-col rounded-lg bg-white shadow hover:shadow-md lg:h-[20rem]" +
        (selectedPropertyId === propertyID
          ? " border-[2.9px] border-gray-900"
          : "")
      }
    >
      <div className=" relative h-[78%] w-full rounded-t-md  bg-gray-100 lg:h-[70%] ">
        <Slider
          propertyImages={hit?.images ?? null}
          propertyData={hit}
          sendEvent={sendEvent}
          loadingProperty={loadingProperty}
          setLoadingProperty={setLoadingProperty}
          isIntersecting={isIntersecting}
          propindex={index}
          count={count}
        />

        <div className=" absolute left-3 top-3 flex flex-row space-x-3">
          {/* {hit.listingType === "RENT" ? (
            <span className="   top-0 rounded-full bg-teal-600 px-4 py-1 text-xs font-semibold uppercase text-blue-100">
              {"For rent"}
            </span>
          ) : (
            <span className="   top-0 rounded-full  bg-lightblue-700  px-4 py-1 text-xs font-semibold uppercase text-blue-100">
              {"For sale"}
            </span>
          )} */}
          {hit.market === "OFF-MARKET" ? (
            <span className="   top-0 rounded-full bg-yellow-700 px-4 py-1 text-xs font-semibold uppercase text-gray-150">
              {"Off Market"}
            </span>
          ) : null}
          {addedWeeks < 5 ? (
            <span className="   top-0 rounded-full bg-purple-700 px-4 py-1 text-xs font-semibold uppercase text-gray-150">
              Added recently
            </span>
          ) : null}
        </div>
      </div>

      <Link
        href={`/homes/${hit.slugShort}`}
        passHref
        prefetch={false}
        // title={title}
      >
        <a
          // href="/"
          // title={title}
          onClick={() => {
            sendEvent("click", hit, "property_clicked");
          }}
          className=" flex  h-[45%] flex-row justify-between rounded-b-md"
        >
          <div className="flex w-full  flex-col ">
            {/* <h2
                title={title}
                className=" truncate font-semibold text-gray-700 lg:font-medium "
              >
                {title}
              </h2> */}

            <div className=" flex flex-row items-center justify-between px-5 pt-3">
              {hit.listingType === "RENT" ? (
                <h3 className=" text-xl font-semibold lg:text-xl">
                  Kshs {Intl.NumberFormat().format(hit.monthlyRent)}/mo
                </h3>
              ) : (
                <h3 className=" text-xl font-semibold lg:text-xl">
                  Kshs {Intl.NumberFormat().format(hit.price)}
                </h3>
              )}
              <div className=" flex flex-row items-center space-x-4 lg:space-x-2">
                {!favorite ? (
                  <MdOutlineFavoriteBorder
                    onClick={async (e) => {
                      e.preventDefault();
                      if (!user) {
                        authModal.setOpen(true);
                        authModal.setActive(1);
                        authModal.setActionMode("SAVE");
                        capture({
                          category: "browse",
                          event: "favorite_click",
                          properties: hit,
                        });

                        return;
                      }
                      if (user && claims.manager) {
                        capture({
                          type: "lister",
                          category: "browse",
                          event: "favorite_click",
                          properties: hit,
                        });

                        return;
                      }
                      await favoriteProperty(
                        user,
                        claims,
                        favorite,
                        setFavorite,
                        hit
                      );
                    }}
                    className="  h-6 w-6  text-gray-700 duration-300 hover:scale-105 "
                  />
                ) : (
                  <MdOutlineFavorite
                    onClick={async (e) => {
                      e.preventDefault();
                      if (!user) {
                        authModal.setOpen(true);
                        authModal.setActive(1);
                        authModal.setActionMode("SAVE");

                        capture({
                          category: "browse",
                          event: "favorite_click",
                          properties: hit,
                        });
                        return;
                      }
                      if (user && claims.manager) {
                        capture({
                          type: "lister",
                          category: "browse",
                          event: "favorite_click",
                          properties: hit,
                        });
                        return;
                      }
                      await favoriteProperty(
                        user,
                        claims,
                        favorite,
                        setFavorite,
                        hit
                      );
                    }}
                    className="  h-6 w-6  text-red-600 duration-300 hover:scale-105 "
                  />
                )}
                <span className=" hidden text-sm font-semibold text-ula-primary hover:underline lg:flex">
                  View
                </span>
                <button
                  aria-label="View property in detail"
                  className=" group flex  h-8 w-8 items-center justify-center rounded-full  bg-gray-200 hover:bg-ula-primary lg:hidden "
                >
                  <MdArrowForwardIos className="h-4 w-4 text-gray-700 group-hover:text-gray-200" />
                </button>
              </div>
            </div>

            <div className="flex flex-row space-x-2 px-5 text-sm text-gray-700">
              <h5 title={`${hit.noOfBedrooms} bedrooms`}>
                {hit.noOfBedrooms}bd{" "}
              </h5>
              <h5 title={`${hit.noOfBathrooms} bathrooms`}>
                {hit.noOfBathrooms}ba{" "}
              </h5>
            </div>

            <div className="flex flex-row justify-between space-x-2 px-5 ">
              <h2 title={title} className="truncate text-gray-700">
                {" "}
                {hit.propertyName
                  ? `${hit.propertyName}, ${
                      !hit.propertyArea?.address_components[0].types.includes(
                        "plus_code"
                      )
                        ? hit.propertyArea?.address_components[0].long_name
                        : hit.propertyArea?.areaName.substring(
                            0,
                            hit.propertyArea?.areaName.indexOf(",")
                          )
                    },  ${hit.propertyTown.townName}`
                  : `${
                      !hit.propertyArea?.address_components[0].types.includes(
                        "plus_code"
                      )
                        ? hit.propertyArea?.address_components[0].long_name
                        : hit.propertyArea?.areaName.substring(
                            0,
                            hit.propertyArea?.areaName.indexOf(",")
                          )
                    }, ${hit.propertyTown.townName}`}
              </h2>
            </div>
            <h4 className=" mt-1 px-5 text-xs font-semibold uppercase text-gray-600">
              {hit.propertyType}
            </h4>
            {color === "red" && router.pathname.includes("/homes") ? (
              <Link
                href={{
                  pathname: `/town/${hit.propertyTown.townSlug}`,
                }}
                prefetch={false}
                as={`/town/${hit.propertyTown.townSlug}`}
                passHref
              >
                <a href={`/town/${hit.propertyTown.townSlug}`}>
                  <div className=" group mt-1 flex flex-row items-center space-x-1 px-5">
                    <span className="  text-ula-secondary group-hover:underline">
                      See all houses in {hit.propertyTown.townName}
                    </span>
                    <AiOutlineArrowRight className=" duration-300 group-hover:translate-x-1 " />
                  </div>
                </a>
              </Link>
            ) : null}

            {/* {town.tag.contactCTA ? (
              <div className="mt-3 flex flex-row justify-between space-x-3 rounded-b-md border border-b-0 border-l-0 border-r-0 border-t border-gray-300  bg-gray-100 px-5  py-2 shadow-md">
                <div className=" flex w-1/2 flex-row justify-center space-x-2 rounded-md border border-gray-700 bg-white px-4 py-2">
                  <IoCallOutline className=" h-6 w-6 text-gray-900 " />
                  <span>Call</span>
                </div>
                <div className=" flex flex-row items-center space-x-1">
                <MdChatBubbleOutline className=" h-6 w-6 text-gray-900 " />
                <span>Message</span>
              </div>
                <div className=" flex w-1/2 flex-row justify-center space-x-2 rounded-md border border-gray-700 bg-white px-4 py-2">
                  <BiLogoWhatsapp className=" h-6 w-6 text-gray-900 " />
                  <span>Whatsapp</span>
                </div>
              </div>
            ) : null} */}
          </div>
        </a>
      </Link>
    </div>
  );
}

export default PropertyTownHit;
